<template>
  <div class="confirm-warp">
    <popup-warp v-model="isAnglPaySetup" class="popup-anglpay">
      <div>
        <div id="anglpay_dom"></div>
        <div class="btn creditcard-btn" @click="onAnglPaySetup">
          {{ i18n.paynow }}
        </div>
      </div>
    </popup-warp>
  </div>
</template>

<script>
import { mapState } from "vuex"
import multicurrencyMixin from "../../mixins/multicurrency"
import { PopupWarp } from "../../components/popup"

export default {
  name: "anglpayPayment",
  mixins: [multicurrencyMixin],
  components: {
    PopupWarp
  },
  computed: {
    ...mapState(["system", "browser"]),
    i18n() {
      return this.$t("confirm")
    }
  },
  data() {
    return {
      isAnglPaySetup: false
    }
  },
  methods: {
    loadAnglPay(paymentInfo) {
      let payInfo = {}
      try {
        payInfo = JSON.parse(paymentInfo)
      } catch (e) {
        console.error("AnglPay-error:", e)
      }
      if (Object.keys(payInfo).length) {
        this.onAnglPayPayment(payInfo, {}, (transaction) => {
          // this.checkOrder(transaction)
          let _path = `/result?tradeNo=${transaction.id}&payMode=AnglPay`
          this.$router.replace(_path)
        })
      }
    },
    checkOrder(tradeNo, payType) {
      let _path = `/result?tradeNo=${tradeNo}&payMode=AnglPay`
      if (payType === "FK") {
        _path = `/result?tradeNo=${tradeNo}&payMode=AnglPay&payType=FK`
      }
      this.$router.replace(_path)
    }
  },
  created() {
    this.Query = this.$route.query
    const { paymentInfo } = this.$route.query
    if (paymentInfo) {
      this.loadScriptSdk("AnglPay", () => {
        this.loadAnglPay(paymentInfo)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-warp {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}
</style>
